import Image from "../Image/Image";
import Popup from "../popup";
import EachRowDetails from "./EachRowDetails";
import { useAppContent, useOccupationContent } from "../../../shared/AppContent";

const Userdatafilledpopup = ({ classesCSS, handlePopUp, userDetail, tabName }) => {
  const { cardTilePageContent, personalDetailsContent, mobileNoContent, cityContent,
    panContent, savedDetailsPopupContent, occupationContent, professionalDetailsContent } = useAppContent();
  const { occupationOptionContent } = useOccupationContent();
  const headersData = {
    personalDetails: `${savedDetailsPopupContent.heading}`,
    professionalDetails: `${savedDetailsPopupContent.heading}`
  }

  //Headings for each user detail
  const personalDetailsData = {
    "firstName": `${personalDetailsContent?.name_container?.headingLabel}`,
    "mobileNo": `${mobileNoContent?.headingLabel}`,
    "resiCity": `${cityContent?.headingLabel}`,
    "panNumber": `${panContent?.headingLabel}`,
    "dob": `${personalDetailsContent?.dob_container?.headingLabel}`,
    "motherName": `${personalDetailsContent?.motherName_container?.headingLabel}`,
    "emailId": `${personalDetailsContent?.email_container?.headingLabel}`
  }
  const professionalDetailsData = {
    "occupation": `${occupationContent?.headingLabel}`,
    "companyName": `${professionalDetailsContent?.company_container?.headingLabel}`,
    "designation": `${professionalDetailsContent?.designation_container?.headingLabel}`,
    "officeAddr": `${professionalDetailsContent?.workAddress_container?.headingLabel}`
  }
  //Converting user details and its headings into key value pairs
  const conevrtDataToArray = (userDetail, headerDetails) => {
    let convertingDatatoArray = [];
    for (let key in headerDetails) {
      if (userDetail.hasOwnProperty(key) && userDetail[key]) {
        let value;
        if (key === "firstName") {
          value = userDetail.firstName +
            " " +
            (userDetail?.middleName ? userDetail.middleName : "") +
            " " +
            userDetail.lastName;
        } else if (key === "mobileNo") {
          value = "+91 " + userDetail[key]
        } else if (key === "officeAddr") {
          value = userDetail.officeAddr?.city ? `${userDetail.officeAddr.addrLine1} ${userDetail.officeAddr.addrLine2}
                  ${userDetail.officeAddr.addrLine3} ${userDetail.officeAddr.pinCode}
                  ${userDetail.officeAddr.city}` : null;
        } else if (key === "occupation") {
          if (userDetail.occupation === 'S') {
            value = occupationOptionContent[0]?.key_name;//'Salaried Person';
          } else if (userDetail.occupation === 'E') {
            value = occupationOptionContent[1]?.key_name;//'Self Employed Person';
          } else {
            value = occupationOptionContent[2]?.key_name;//'Retired Person';
          }
        } else {
          value = userDetail[key];
        }
        convertingDatatoArray.push({
          key: headerDetails[key],
          value
        });
      }
    }
    return convertingDatatoArray;
  };
  const createAllRows = (userDetail) => {
    let finalUI = [];
    //Based on tab selection get the heading of each user details Ex:personalDetailsData
    let defaultFields =
      tabName === "personalDetails" ? personalDetailsData : professionalDetailsData;
    let convertingDatatoArray = conevrtDataToArray(userDetail, defaultFields);
    //Add each userdetails div dynamically
    for (let l = 0; l < convertingDatatoArray.length; l++) {
      finalUI.push(
        <EachRowDetails
          classesCSS={classesCSS}
          key={l}
          convertingDatatoArray={convertingDatatoArray[l]}
        />
      );
    }
    return tabName === "personalDetails" ?
      <div className={classesCSS.wrapper}>{finalUI}</div> :
      <div className={classesCSS.wrapperProfessional}>{finalUI}</div>
  };
  userDetail.popupHeader =
    tabName === "personalDetails" ? headersData.personalDetails : headersData.professionalDetails;
  return (
    <Popup
      header={
        <div className={classesCSS.perosnalDetailsPopupHeaderDiv}>
          <span className={classesCSS.perosnalDetailsPopupHeader}>
            {tabName === "personalDetails" ?
              `${cardTilePageContent?.step_tiles?.personal_detail?.heading}` :
              `${cardTilePageContent?.step_tiles?.professional_detail?.heading}`}
            {" "}
          </span>
          <span className={classesCSS.CloseIcon} onClick={handlePopUp}>
            <Image filename={"Path -5"} ext={"png"} renditions={["2x"]} />
          </span>
        </div>
      }
      content={
        <div className={classesCSS.personalDetailsTabBody}>
          <div className={classesCSS.Summaryheader}>
            {userDetail.popupHeader}
          </div>
          {createAllRows(userDetail)}
        </div>
      }
      isCustom={true}
      PopupBox={classesCSS.PopupBox}
      Box={classesCSS.Box}
      CloseBtn={classesCSS.CloseBtn}
      closePrimaryButton={classesCSS.closePrimaryButton}
      handleClose={handlePopUp}
      buttonLabel={savedDetailsPopupContent.closeButton}
    />
  );
};

export default Userdatafilledpopup;
